"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateConsentsState = exports.setDefaultConsentsState = exports.getPrefixedCookieName = exports.ConsentState = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
var ConsentState;
(function (ConsentState) {
    ConsentState["Denied"] = "denied";
    ConsentState["Granted"] = "granted";
})(ConsentState || (exports.ConsentState = ConsentState = {}));
const getPrefixedCookieName = (entryName, { cookiePrefix }) => {
    return cookiePrefix === 'managed' ? `managed-${entryName}` : entryName;
};
exports.getPrefixedCookieName = getPrefixedCookieName;
const setDefaultConsentsState = () => {
    if (typeof window === 'undefined') {
        return;
    }
    if (typeof window.gtag !== 'undefined') {
        window.gtag('consent', 'default', {
            ad_storage: ConsentState.Denied,
            ad_user_data: ConsentState.Denied,
            ad_personalization: ConsentState.Denied,
            analytics_storage: ConsentState.Denied,
        });
    }
};
exports.setDefaultConsentsState = setDefaultConsentsState;
const updateConsentsState = (consentParams, options) => {
    if (typeof window === 'undefined') {
        return;
    }
    window.analytics?.ready(() => {
        if (typeof window.gtag !== 'undefined') {
            window.gtag('consent', 'update', consentParams);
        }
    });
    Object.entries(consentParams).forEach(([entryName, consentValue]) => {
        const prefixedCookie = (0, exports.getPrefixedCookieName)(entryName, options);
        js_cookie_1.default.set(prefixedCookie, consentValue, {
            expires: 60,
            ...(window.location.hostname !== 'localhost' && { domain: '.pleo.io' }),
        });
    });
};
exports.updateConsentsState = updateConsentsState;
